import React from 'react';
import { useNavigate } from 'react-router-dom';
import './CarsItem.css'

const CarsItem = ({ car }) => {
     const { _id, quantity, name, img, description, price, supplierName } = car;
     const navigate = useNavigate()

     const navigateToCarDetails = id => {
          navigate(`/Inventory/${id}`);

     }



     return (
          <div className='cars-item'>
               <img src={img} alt="" />

               <div className="cars-item-info">
                    <h6>{name}</h6>
                    <p><small>Description : {description}</small></p>
                    <h6>Price : $ {price}</h6>
                    <p><small>Supplier Name : {supplierName}</small></p>
                    <p>Quantity : {quantity}</p>

                    <button onClick={() => navigateToCarDetails(_id)} className='btn btn-primary py-2 mb-3 fw-bolder'><small>UPDATE CAR 🡲</small></button>

               </div>




          </div>
     );
};

export default CarsItem;